import * as _envUtils from './env-utils';

// export utils by *.js
export const envUtils = _envUtils;

export * from './browser-utils';
export * from './escape-string-for-regex';
export * from './global-event-target';
export * from './growi-theme-metadata';
export * as deepEquals from './is-deep-equals';
export * as objectIdUtils from './objectid-utils';
export * as pagePathUtils from './page-path-utils';
export * as pageUtils from './page-utils';
export * as pathUtils from './path-utils';
// export utils with namespace
export * as templateChecker from './template-checker';
